import { Carousel } from "react-bootstrap";
import Message from "./Message";
import Loader from "./Loader";
import {
  useGetTopOrderReviewsQuery,
  useGetTopProductReviewsQuery,
} from "../slices/reviewApiSlice";
import { dateFormatterShort } from "../utils/dateHelper.js";
import Rating from "./Rating.jsx";

const ReviewCarousel = () => {
  const {
    data: orderReviews,
    isLoading: isLoadingOrderReviews,
    error: errorOrderReviews,
  } = useGetTopOrderReviewsQuery();

  const {
    data: productReviews,
    isLoading: isLoadingProductReviews,
    error: errorProductReviews,
  } = useGetTopProductReviewsQuery();

  if (isLoadingOrderReviews || isLoadingProductReviews) return <Loader />;
  if (errorOrderReviews)
    return (
      <Message variant="danger">
        {errorOrderReviews?.data?.error || errorOrderReviews.error}
      </Message>
    );
  if (errorProductReviews)
    return (
      <Message variant="danger">
        {errorProductReviews?.data?.error || errorProductReviews.error}
      </Message>
    );

  const orderReviewList = orderReviews || [];
  const producReviewtList = productReviews || [];

  // Interleave reviews
  const maxLength = Math.max(orderReviewList.length, producReviewtList.length);
  const reviews = [];
  for (let i = 0; i < maxLength; i++) {
    if (orderReviewList[i]) reviews.push(orderReviewList[i]);
    if (producReviewtList[i]) reviews.push(producReviewtList[i]);
  }

  return (
    reviews.length > 0 && (
      <Carousel pause="hover" className="bg-primary mb-4">
        {reviews.map((review) => (
          <Carousel.Item key={review._id}>
            {/* force height so slides are visible */}
            <div
              className="d-flex flex-column justify-content-center align-items-center"
              style={{ minHeight: "200px", padding: "20px" }}
            >
              <h3 className="text-light text-center">"{review.comment}"</h3>
              <h5 className="text-light text-center">{review.product?.name && (
                <>
                 for {review.product?.name}
                </>
                )}
              </h5>
              <Rating value={review.rating} text={` - ${review.user?.name || "Anonymous"}`}/>
              <p className="text-light">
                Reviewed on {dateFormatterShort(review.createdAt)}
              </p>
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    )
  );
};

export default ReviewCarousel;